<app-quick-action-dialog
  [isOpen]="isDialogOpen"
  [title]="'Delete wallet'"
  [isCloseable]="true"
  (backdropClick)="onBackdropClick()"
  (close)="onClose()"
>
  <div slot="content" class="delete-confirmation">
    @if (!isLastWallet()) {
      <p>
        Are you sure you want to delete the wallet
        <strong>{{ walletName }}</strong
        >? This will remove all accounts associated with this wallet from this
        device.
      </p>
    }
    @if (isLastWallet()) {
      <p>
        You can't delete the last wallet. You can remove only all wallets info
        from the settings menu.
      </p>
    }
  </div>

  <div slot="footer" class="button-row">
    <kc-button
      [text]="'Cancel'"
      [variant]="'secondary'"
      [size]="'m'"
      [isFullWidth]="true"
      (buttonClick)="onCancel()"
    />
    <kc-button
      class="kc-button-danger"
      [text]="'Delete wallet'"
      [variant]="'secondary'"
      [size]="'m'"
      [isFullWidth]="true"
      [isDisabled]="isLastWallet()"
      (buttonClick)="onDelete()"
    />
  </div>
</app-quick-action-dialog>
